import api from '../components/api';

export const login = async (userData) => {
  const response = await api.post("/auth/login", userData);
  const data = response.data;
  const authHeader = response.headers['authorization'] || response.headers['Authorization'];
  let token = null;
  
  // Extract token from Authorization header if it exists
  if (authHeader) {
    const parts = authHeader.split(' ');
    if (parts.length === 2 && parts[0] === 'Bearer') {
      token = parts[1];
    }

  }

  // Add token to response data
  return {
    ...data,
    jwtToken: token,
  };
};

export const register = async (userData) => {
  const response = await api.post("/auth/signup", userData);
  return response.data;
};

export const updateUser = async (userData) => {
  const response = await api.put("/auth/update-profile", userData);
  return await response.data;
};

export const logout = async () => {
  const response = await api.post("/auth/logout");
  return await response.data;
};

// Helper functions for token management
export const isAuthenticated = () => {
  const token = localStorage.getItem('accessToken');
  return !!token;
};

export const getToken = () => {
  return localStorage.getItem('accessToken');
};

export const setToken = (token) => {
  localStorage.setItem('token', token);
};

export const removeToken = () => {
  localStorage.removeItem('token');
};

